import NavItem from './NavItem';
import ApplicationRecord from './ApplicationRecord';

export default class Product
  extends ApplicationRecord({
    ID: 1,
    ArtID: '',
    Label: '',
    Densite: '',
    _embedded: {},
  }) {
  /**
   * Product File
   * @return {NavItem}
   */
  file() {
    return this._getOne('File', NavItem);
  }

  /**
   * Return the name of the project used when
   * talking about it specifically.
   * Like in select tags.
   * @return {String}
   */
  commonName() {
    if (this.Densite) return this.Label + ', ' + this.Densite + ' to./m3';
    return this.Label;
  }
}



// WEBPACK FOOTER //
// ./src/models/Product.js